import { TranslateService } from '@ngx-translate/core';
import { Injectable, OnDestroy } from '@angular/core';
// RxJS
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubHeaderService implements OnDestroy {

	title$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  subTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  destroy$ = new Subject();

	constructor(private traslateService: TranslateService) {
	}

  setTitle(title: string) {
    queueMicrotask(() => this.title$.next(title));
  }

  setSubTitle(subTitle: string) {
    queueMicrotask(() => this.subTitle$.next(subTitle));
  }

  get title(): Observable<string> {
    return this.title$.asObservable();//.pipe(map(t => this.traslateService.instant(t)));
  }

  get subTitle(): Observable<string> {
    return this.subTitle$.asObservable();//.pipe(map(t => this.traslateService.instant(t)));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
